export const VIEW_LOGIN_ID = 'view_login_id';
export const VIEW_LOGIN_ID_ERR = 'view_login_id_err';
export const VIEW_STUDENTS = 'view_students';

//students
export const VIEW_USERS = 'view_users';
export const DID_LOGIN = 'did_login';
export const ACTIVATE = 'do_activate';
export const REGISTERED = 'do_register';

export const DID_LOGOUT = 'did_logout';

//Upload
export const EXPORT_DB = 'export_db';

//Questions
export const VIEW_QUESTIONS = 'view_questions';
export const ON_ERROR = 'ON_ERROR';

export const LOADING = 'Loading';
export const SUCCESS = 'success';
export const FAILED = 'failed';
export const DISMISS = 'dismiss';
